export default __webpack_public_path__ + "static/media/observatoryKlein.4cae3745.jpg";